import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Top from '../views/Top.vue';
import About from '../views/About.vue'
import DanOni from '../views/DanOni.vue';
import DanOniPlayer from '../views/DanOniPlayer.vue';
import Tools from '../views/Tools.vue';
import ErrorNotFound from '../views/ErrorNotFound.vue';


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Top,
  },
  {
    path: '/about',
    component: About,
  },
  {
    path: '/danoni',
    component: DanOni,
  }, 
  {
    path: '/danoni/:source',
    component: DanOniPlayer,
  },
  {
    path: '/tools',
    component: Tools,
  },
  {
    path: '*',
    component: ErrorNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
